<div class="license-error-container">
  <div
    class="bg-white rounded-2xl shadow-2 p-5 w-full"
    style="max-width: 28rem">
    <!-- Loading skeleton -->
    <ng-container *ngIf="isLoading; else content">
      <div class="flex flex-column align-items-center gap-3 mb-4">
        <p-skeleton
          shape="circle"
          size="4rem"></p-skeleton>
        <p-skeleton
          width="12rem"
          height="1.5rem"></p-skeleton>
      </div>
      <div class="flex flex-column gap-3 mb-4">
        <div class="flex justify-content-between align-items-center py-2">
          <p-skeleton
            width="6rem"
            height="0.875rem"></p-skeleton>
          <p-skeleton
            width="8rem"
            height="0.875rem"></p-skeleton>
        </div>
        <p-skeleton
          width="100%"
          height="1rem"></p-skeleton>
      </div>
    </ng-container>

    <!-- Content -->
    <ng-template #content>
      <!-- Header -->
      <div
        class="flex flex-column align-items-center gap-3 mb-4"
        [ngSwitch]="status">
        <ng-container *ngSwitchCase="'EXPIRED'">
          <div class="icon-circle bg-red-100">
            <i class="pi pi-times-circle text-3xl text-red-500"></i>
          </div>
          <h2 class="text-xl font-bold text-900">Licenza Scaduta</h2>
        </ng-container>
        <ng-container *ngSwitchCase="'INACTIVE'">
          <div class="icon-circle bg-yellow-100">
            <i class="pi pi-exclamation-triangle text-3xl text-yellow-600"></i>
          </div>
          <h2 class="text-xl font-bold text-900">Licenza Inattiva</h2>
        </ng-container>
        <ng-container *ngSwitchCase="'NOT_FOUND'">
          <div class="icon-circle bg-red-100">
            <i class="pi pi-search text-3xl text-red-500"></i>
          </div>
          <h2 class="text-xl font-bold text-900">Licenza Non Trovata</h2>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <div class="icon-circle bg-red-100">
            <i class="pi pi-exclamation-circle text-3xl text-red-500"></i>
          </div>
          <h2 class="text-xl font-bold text-900">Errore Licenza</h2>
        </ng-container>
      </div>

      <!-- Details -->
      <div [ngSwitch]="status">
        <!-- INACTIVE -->
        <ng-container *ngSwitchCase="'INACTIVE'">
          <div class="flex flex-column gap-3 mb-4">
            <div class="flex justify-content-between py-2 border-bottom-1 surface-border">
              <span class="text-500 text-sm">Stato</span>
              <p-chip styleClass="p-chip-warning">
                <span class="uppercase text-xs font-bold">{{ status! | licenseStatus }}</span>
              </p-chip>
            </div>
            <ng-container *ngIf="data">
              <div class="flex justify-content-between py-2 border-bottom-1 surface-border">
                <span class="text-500 text-sm">Codice licenza</span>
                <span class="font-semibold text-900">{{ data.code }}</span>
              </div>
              <div class="flex justify-content-between py-2 border-bottom-1 surface-border">
                <span class="text-500 text-sm">Cliente</span>
                <span class="font-semibold text-900">{{ data.customer }}</span>
              </div>
              <div class="flex justify-content-between py-2 border-bottom-1 surface-border">
                <span class="text-500 text-sm">Data attivazione</span>
                <span class="font-semibold text-900">{{
                  data.valid_from | date: 'dd/MM/yyyy'
                }}</span>
              </div>
              <div class="flex justify-content-between py-2 border-bottom-1 surface-border">
                <span class="text-500 text-sm">Data scadenza</span>
                <span class="font-semibold text-900">{{ data.valid_to | date: 'dd/MM/yyyy' }}</span>
              </div>
            </ng-container>
            <p class="text-sm text-500 mt-2">
              La licenza non è ancora attiva. Attendere la data di attivazione prevista.
            </p>
          </div>
        </ng-container>

        <!-- EXPIRED -->
        <ng-container *ngSwitchCase="'EXPIRED'">
          <div class="flex flex-column gap-3 mb-4">
            <div class="flex justify-content-between py-2 border-bottom-1 surface-border">
              <span class="text-500 text-sm">Stato</span>
              <p-chip styleClass="p-chip-danger">
                <span class="uppercase text-xs font-bold">{{ status! | licenseStatus }}</span>
              </p-chip>
            </div>
            <ng-container *ngIf="data">
              <div class="flex justify-content-between py-2 border-bottom-1 surface-border">
                <span class="text-500 text-sm">Codice licenza</span>
                <span class="font-semibold text-900">{{ data.code }}</span>
              </div>
              <div class="flex justify-content-between py-2 border-bottom-1 surface-border">
                <span class="text-500 text-sm">Cliente</span>
                <span class="font-semibold text-900">{{ data.customer }}</span>
              </div>
              <div class="flex justify-content-between py-2 border-bottom-1 surface-border">
                <span class="text-500 text-sm">Data attivazione</span>
                <span class="font-semibold text-900">{{
                  data.valid_from | date: 'dd/MM/yyyy'
                }}</span>
              </div>
              <div class="flex justify-content-between py-2 border-bottom-1 surface-border">
                <span class="text-500 text-sm">Data scadenza</span>
                <span class="font-semibold text-red-500 font-bold">{{
                  data.valid_to | date: 'dd/MM/yyyy'
                }}</span>
              </div>
            </ng-container>
            <p class="text-sm text-500 mt-2">
              La licenza è scaduta. Contattare il supporto per il rinnovo.
            </p>
          </div>
        </ng-container>

        <!-- NOT_FOUND -->
        <ng-container *ngSwitchCase="'NOT_FOUND'">
          <div class="flex flex-column gap-3 mb-4">
            <ng-container *ngIf="data; else notFoundGeneric">
              <p class="text-sm text-500 text-center line-height-3">
                La licenza con codice <strong class="text-900">{{ data.code }}</strong> e nome
                cliente
                <strong class="text-900">{{ data.customer }}</strong>
                non è stata trovata.
              </p>
            </ng-container>
            <ng-template #notFoundGeneric>
              <p class="text-sm text-500 text-center">
                La licenza non è stata trovata nel sistema.
              </p>
            </ng-template>
          </div>
        </ng-container>

        <!-- ERROR (default) -->
        <ng-container *ngSwitchDefault>
          <div class="flex flex-column gap-3 mb-4">
            <p class="text-sm text-500 text-center">
              Si è verificato un errore nel recupero dei dati della licenza.
            </p>
          </div>
        </ng-container>
      </div>
    </ng-template>

    <!-- Retry button -->
    <button
      pButton
      label="Riprova"
      icon="pi pi-refresh"
      class="p-button-outlined w-full"
      [loading]="isRetrying"
      (click)="retry()"></button>
    <!--div class="flex justify-content-center p-2">
      <small>
        Contattaci direttamente.
        <a
          class="text-primary"
          href="https://www.zetra.it"
          target="_blank"
          >Zetra</a
        >
      </small>
    </div-->
  </div>
</div>
